import { Link } from 'react-router-dom';

interface VideoCardProps {
  id: number;
  title: string;
  category: string;
  categorySlug: string;
  platform: string;
  image: string;
  rating: number;
  updateInfo: string;
  isHot?: boolean;
  isNew?: boolean;
}

export default function VideoCard({
  id,
  title,
  category,
  categorySlug,
  platform,
  image,
  rating,
  updateInfo,
  isHot,
  isNew,
}: VideoCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="block group cursor-pointer"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
    >
      <div className="relative overflow-hidden rounded-lg aspect-video bg-background-200">
        <img
          src={image}
          alt={title}
          title={`${title} - 豆花视频免费在线观看`}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-2 left-2 flex items-center gap-1.5">
          {isHot && (
            <span className="px-2 py-0.5 text-xs font-medium bg-accent-500 text-background-50 rounded-full whitespace-nowrap">
              热播
            </span>
          )}
          {isNew && (
            <span className="px-2 py-0.5 text-xs font-medium bg-secondary-500 text-background-50 rounded-full whitespace-nowrap">
              新上
            </span>
          )}
        </div>
        <div className="absolute top-2 right-2">
          <span className="px-2 py-0.5 text-xs font-bold bg-background-950/70 text-amber-400 rounded whitespace-nowrap">
            {rating}
          </span>
        </div>
        <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-3">
          <span className="text-xs text-background-50/90 whitespace-nowrap">
            {updateInfo}
          </span>
        </div>
      </div>
      <div className="mt-2.5">
        <h3 className="text-sm font-medium text-foreground-900 group-hover:text-primary-500 transition-colors line-clamp-1 font-heading">
          {title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-500">{category}</span>
          <span className="text-xs text-foreground-400">·</span>
          <span className="text-xs text-foreground-400">{platform}</span>
        </div>
      </div>
    </Link>
  );
}